import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M16 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M18.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M15.5 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M7 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9 19v4.622c.959.247 1.964.378 3 .378 6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12c0 1.784.39 3.478 1.088 5H7a2 2 0 0 1 2 2m13.5-7c0 5.799-4.701 10.5-10.5 10.5q-.765 0-1.5-.106V19A3.5 3.5 0 0 0 7 15.5H2.097A10.5 10.5 0 0 1 1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }